import React, { useRef, useState } from "react";
import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";

const ERROR_TEXT = "Unable to download photos. Please try again.";

// 生成合法文件名:去掉控制字符和 Windows 非法字符,去掉结尾的点和空格
const toFileName = (value, fallback) =>
  String(value || fallback)
    .replace(/[\x00-\x1f\x7f\\/:*?"<>|]/g, "_")
    .trim()
    .replace(/[. ]+$/, "") || String(fallback);

const saveBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export default function DownloadMaintenancePhotosButton({
  maintenanceId,
  requestNo,
}) {
  const [loading, setLoading] = useState(false);
  const downloading = useRef(false); // 防止连点重复下载

  const download = async () => {
    if (!maintenanceId || downloading.current) return;
    downloading.current = true;
    setLoading(true);

    try {
      const blob = await http.get(api.downloadMaintenanceFiles, {
        params: { maintenanceId },
        responseType: "blob",
      });

      if (!(blob instanceof Blob)) {
        message.error(ERROR_TEXT);
        return;
      }
      if (blob.type.includes("json")) {
        const result = JSON.parse(await blob.text());
        message.error(result?.msg || ERROR_TEXT);
        return;
      }

      if (!blob.size || !blob.type.includes("zip")) {
        message.error(ERROR_TEXT);
        return;
      }

      saveBlob(blob, `${toFileName(requestNo, maintenanceId)}.zip`);
    } catch (e) {
      console.error(e);
      message.error(ERROR_TEXT);
    } finally {
      downloading.current = false;
      setLoading(false);
    }
  };

  
  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      loading={loading}
      disabled={!maintenanceId}
      onClick={download}
    >
      Download Photos
    </Button>
  );
}
